import { renderHistoryConsole } from './history-renderer.js'

function createElement(tag, attrs, children) {
  var el = document.createElement(tag)
  attrs = attrs || {}
  Object.keys(attrs).forEach(function (k) { if (k === 'class') el.className = attrs[k]; else el.setAttribute(k, attrs[k]) })
  ;(children || []).forEach(function (c) {
    if (c === null || c === undefined) return
    el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c)
  })
  return el
}

function ensureHistoryPopin(state) {
  if (state.popin) return state.popin

  var overlay = createElement('div', { class: 'wc-history-overlay', hidden: 'hidden' })
  var popin = createElement('div', { class: 'wc-history-popin', role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Historique de session' })
  var close = createElement('button', { class: 'wc-history-close', type: 'button', 'aria-label': 'Fermer' }, ['×'])
  var title = createElement('div', { class: 'wc-history-title' })
  title.appendChild(createElement('span', {}, ['Historique de session']))
  if (state.version) {
    title.appendChild(createElement('span', { class: 'wc-history-version' }, ['v' + state.version]))
  }
  var body = createElement('div', { class: 'wc-history-body' })

  close.addEventListener('click', function () {
    overlay.setAttribute('hidden', 'hidden')
  })
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) overlay.setAttribute('hidden', 'hidden')
  })

  popin.appendChild(close)
  popin.appendChild(title)
  popin.appendChild(body)
  overlay.appendChild(popin)
  document.body.appendChild(overlay)

  state.popin = { overlay: overlay, body: body }
  return state.popin
}

function renderHistoryPopin(state, payload) {
  var popin = ensureHistoryPopin(state)
  var history = payload && (payload.history || payload.result.events || payload.result)
  var items = Array.isArray(history) ? history : []

  if (!items.length) {
    popin.body.innerHTML = '<div class="wc-history-empty">Aucun historique disponible.</div>'
  } else {
    popin.body.innerHTML = items.map(function (entry, index) {
      return renderHistoryConsole(entry, index)
    }).join('')
  }

  popin.overlay.removeAttribute('hidden')
  return popin
}

export { renderHistoryPopin }
